import { useMemo } from 'react';
import { View } from 'react-native';
import { shallow } from 'zustand/shallow';
import styles from './styles';
import { useDiscoverStore } from '../../../../zustand-stores';
import { ProgramTypeEnum } from '../../../../shared/program-type-enum';
import { MainTabEnum, SubTabEnum } from '../../../../shared/discover-tabs-enum';
import {
  PlayWithFriendsPopFilter,
  ProgramTypePopFilter,
  PremierPopFilter,
  VoloPassExclusivePopFilter,
} from './components';

/*
  MainTab keys can have either:
  1. An array of pop-filters that are applied to all of it's sub-tabs
  2. An object with sub-tab keys that contain individual arrays for each sub-tab.
*/

type PopFilterConfig = {
  [mainTabKey: string]:
    | JSX.Element[]
    | {
        [subTabKey: string]: JSX.Element[];
      };
};

const PopFiltersByView: PopFilterConfig = {
  [MainTabEnum.EVENTS]: [
    <VoloPassExclusivePopFilter key="volopass-only" />,
    <PremierPopFilter key="premier" />,
  ],
  [MainTabEnum.CLASSES]: {
    [SubTabEnum.DAILY]: [
      <PremierPopFilter key="premier" />,
      <VoloPassExclusivePopFilter key="volopass-only" />,
    ],
    [SubTabEnum.SERIES]: [<PremierPopFilter key="premier" />],
  },
  [MainTabEnum.SPORTS]: {
    [SubTabEnum.LEAGUE]: [<PremierPopFilter key="premier" />],
    [SubTabEnum.SERIES]: [<PremierPopFilter key="premier" />],
    [SubTabEnum.TOURNAMENT]: [
      <PremierPopFilter key="premier" />,
      <VoloPassExclusivePopFilter key="volopass-only" />,
    ],
    [SubTabEnum.DAILY]: [
      <ProgramTypePopFilter key="pickup" programType={ProgramTypeEnum.PICKUP} />,
      <ProgramTypePopFilter key="dropin" programType={ProgramTypeEnum.DROPIN} />,
      <PlayWithFriendsPopFilter key="playwithfriends" />,
      <VoloPassExclusivePopFilter key="volopass-only" />,
      <PremierPopFilter key="premier" />,
    ],
  },
};

const PopFilterBar = () => {
  const { view, subView } = useDiscoverStore(
    store => ({
      view: store.view,
      subView: store.subView,
    }),
    shallow
  );

  const PopFilterComponent = useMemo(() => {
    const main = PopFiltersByView[view];
    if (Array.isArray(main)) {
      return main;
    }
    if (main?.[subView]) {
      return main[subView];
    }
    return null;
  }, [view, subView]);

  return <View style={styles.container}>{PopFilterComponent}</View>;
};

export default PopFilterBar;
